module.exports = __webpack_public_path__ + "static/media/PinUp.22ea0fc6.svg";